// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 480px) {
  .card {
    margin-left: 20px;
    margin-right: 20px;
  }
}

.card-info {
  padding-top: 15px;
  padding-bottom: 15px;
  background-color: white;
}

.info-block {
  margin-left: 12px;
  margin-right: 12px;
  gap: 20px;
}

.submission-status {
  flex-grow: 1;
}

.hover-click {
  cursor: pointer;
  width: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Application/components/ApplicationCardList/ApplicationCard.css"],"names":[],"mappings":"AAAA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":["@media screen and (max-width: 480px) {\n  .card {\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n}\n\n.card-info {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  background-color: white;\n}\n\n.info-block {\n  margin-left: 12px;\n  margin-right: 12px;\n  gap: 20px;\n}\n\n.submission-status {\n  flex-grow: 1;\n}\n\n.hover-click {\n  cursor: pointer;\n  width: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
